/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Body_chooseRecoveryAuthenticator } from '../models/Body_chooseRecoveryAuthenticator';
import type { FactorType } from '../models/FactorType';
import type { RecoveryCompleteRequest } from '../models/RecoveryCompleteRequest';
import type { RecoveryNotMeRequest } from '../models/RecoveryNotMeRequest';
import type { RecoveryPushChallengeStatusResponse } from '../models/RecoveryPushChallengeStatusResponse';
import type { RecoveryResendOTPResponse } from '../models/RecoveryResendOTPResponse';
import type { RecoveryStartRequest } from '../models/RecoveryStartRequest';
import type { RecoveryStartResponse } from '../models/RecoveryStartResponse';
import type { RecoverySubmitRequest } from '../models/RecoverySubmitRequest';
import type { RecoverySubmitResponse } from '../models/RecoverySubmitResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MobileRecoveryService {
    /**
     * Start the recovery flow
     * @param requestBody
     * @returns RecoveryStartResponse Successful Response
     * @throws ApiError
     */
    public static startRecovery(
        requestBody: RecoveryStartRequest,
    ): CancelablePromise<RecoveryStartResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recovery/mobile/start',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Invalid request`,
                401: `Recovery failed`,
                404: `Recovery flow not available`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
                500: `Enrollment returned an invalid flow state`,
            },
        });
    }
    /**
     * Submit a recovery answer
     * Submit one answer; returns next question (IN_PROGRESS) or terminal verdict.
     * @param requestBody
     * @param xSessionToken
     * @returns RecoverySubmitResponse Successful Response
     * @throws ApiError
     */
    public static submitRecovery(
        requestBody: RecoverySubmitRequest,
        xSessionToken?: (string | null),
    ): CancelablePromise<RecoverySubmitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recovery/mobile/submit',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Missing or invalid X-Session-Token, or rejected by enrollment`,
                404: `Recovery flow not available`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
                500: `Enrollment returned an invalid flow state`,
            },
        });
    }
    /**
     * List authenticator alternatives at the current paused step
     * Return factor types the client may pick from at the current paused step.
     * @param xSessionToken
     * @returns FactorType Successful Response
     * @throws ApiError
     */
    public static getRecoveryAuthenticatorAlternatives(
        xSessionToken?: (string | null),
    ): CancelablePromise<Array<FactorType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/recovery/mobile/authenticator-alternatives',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            errors: {
                400: `Flow is not at a paused selection point`,
                401: `Missing or invalid X-Session-Token`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
                500: `Enrollment returned an invalid flow state`,
            },
        });
    }
    /**
     * Switch the active factor at the current paused step
     * Switch the active factor; initialize its challenge and update session pointers.
     * @param requestBody
     * @param xSessionToken
     * @returns RecoverySubmitResponse Successful Response
     * @throws ApiError
     */
    public static chooseRecoveryAuthenticator(
        requestBody: Body_chooseRecoveryAuthenticator,
        xSessionToken?: (string | null),
    ): CancelablePromise<RecoverySubmitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recovery/mobile/choose-authenticator',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Flow is not at a paused selection point, or selected authenticator is not an available alternative`,
                401: `Missing or invalid X-Session-Token`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
                500: `Enrollment returned an invalid flow state`,
            },
        });
    }
    /**
     * Resend OTP for the current recovery step (SMS or Email).
     * Resend the OTP challenge for the active SMS or Email recovery step.
     * @param xSessionToken
     * @returns RecoveryResendOTPResponse Successful Response
     * @throws ApiError
     */
    public static resendRecoveryOtp(
        xSessionToken?: (string | null),
    ): CancelablePromise<RecoveryResendOTPResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recovery/mobile/otp/resend',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            errors: {
                400: `Flow is at a paused selection point (no active step), current step is not an OTP factor, or cooldown active`,
                401: `Missing or invalid X-Session-Token`,
                404: `Recovery flow not available`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Poll the push challenge status for the current recovery step.
     * Read-only poll of the push challenge status at the active recovery step.
     * @param xSessionToken
     * @returns RecoveryPushChallengeStatusResponse Successful Response
     * @throws ApiError
     */
    public static getRecoveryPushChallengeStatus(
        xSessionToken?: (string | null),
    ): CancelablePromise<RecoveryPushChallengeStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/recovery/mobile/push-challenge-status',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            errors: {
                400: `Flow is at a paused selection point (no active step), or current step is not a push challenge`,
                401: `Missing or invalid X-Session-Token`,
                404: `Recovery flow not available`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
    /**
     * Complete the recovery flow
     * Complete the recovery flow.
     * @param requestBody
     * @param xSessionToken
     * @returns RecoverySubmitResponse Successful Response
     * @throws ApiError
     */
    public static completeRecovery(
        requestBody: RecoveryCompleteRequest,
        xSessionToken?: (string | null),
    ): CancelablePromise<RecoverySubmitResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recovery/mobile/complete',
            headers: {
                'X-Session-Token': xSessionToken,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Missing or invalid X-Session-Token`,
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
                500: `Completion failed (retryable)`,
            },
        });
    }
    /**
     * Stop an in-flight recovery flow from the start email's 'not me' link
     * Forward to enrollment; always 204 — never leak whether a flow exists.
     * @param requestBody
     * @returns void
     * @throws ApiError
     */
    public static reportRecoveryNotMe(
        requestBody: RecoveryNotMeRequest,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/recovery/mobile/not-me',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
                426: `Client app version is below the minimum supported version`,
            },
        });
    }
}
